import { defineMessages } from 'react-intl';

const messages = defineMessages({
  noTableDataDefault: {
    id: 'noTableDataDefault',
    defaultMessage: 'There is no data to show.'
  }
});

export default messages;
